/**
 * Méthodes de paiement considérées comme "espèces" (UUID + libellés legacy, pour couvrir
 * tous les formats de stockage de payment_method). Source unique — ne pas redupliquer.
 */
export const CASH_PAYMENT_VALUES = new Set<string>([
  '291396f4-4338-4330-aa02-00d400d41714', // Espèces (UUID)
  'bfbd3cca-9fcc-4fcd-835e-b05b83ed9b8c', // Bon d'achat (UUID)
  'e5f00614-0e2e-47a9-bb5a-26e6580d02aa', // Espèce à la livraison (UUID)
  'Espèces',
  "Bon d'achat",
  'Espèce à la livraison',
]);
